import React, { memo, useMemo } from 'react';
import './index.scss';

interface IProps {
    /** 要显示的列数 */
    columns: number;
    /** 要显示的行数 */
    count: number;
    /** 是否展示条纹动画 */
    showStripes?: boolean;
    /** 单元格高度 */
    cellHeight?: number | string;
}

const TableSkeleton: React.FC<IProps> = ({ columns, count, showStripes = false, cellHeight = 20 }) => {
    const itemClass = useMemo(() => {
        let className = 'umu-skeleton-item';
        if (showStripes) {
            className += ' umu-skeleton-stripes';
        }
        return className;
    }, [showStripes]);

    return (
        <table style={{ width: '100%', border: '1px solid #eee' }}>
            <thead>
                <tr>
                    {[...Array(columns)].map((_, index) => (
                        <th key={index} style={{ padding: 0, backgroundColor: '#f5f5f5' }}>
                            <div
                                style={{
                                    padding: '12px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '48px',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <div
                                    className={itemClass}
                                    style={{ marginBottom: 0, width: '50%', height: cellHeight }}
                                ></div>
                            </div>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {[...Array(count)].map((_, rowIndex) => (
                    <tr key={rowIndex}>
                        {[...Array(columns)].map((_, colIndex) => (
                            <td
                                key={colIndex}
                                style={{ borderTop: '1px solid #eee', padding: 0, backgroundColor: '#fff' }}
                            >
                                <div
                                    style={{
                                        padding: '12px 24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '48px',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <div
                                        className={itemClass}
                                        style={{
                                            marginBottom: 0,
                                            width: rowIndex % 2 === 0 ? '40%' : '50%',
                                            height: cellHeight,
                                        }}
                                    ></div>
                                </div>
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default memo(TableSkeleton);
